import { createSlice } from "@reduxjs/toolkit";

import { onBoardForm } from "../../utilities/constants";

const initialState = {
  value: localStorage.getItem('selfValues') ? JSON.parse( localStorage.getItem('selfValues')) : onBoardForm,
  successData: {},
  isUpdate: false,
  fromDashboard: localStorage.getItem('fromDashboard') ? localStorage.getItem('fromDashboard') :false,
  talentStatus: 0,
  formOptions: {},
  userId: localStorage.getItem('userId') || ""
};

export const selfIntroStepOneFormReducer = createSlice({
  name: "selfIntroOne",
  initialState,
  reducers: {
    updateValues: (state, action) => {
      localStorage.setItem('selfValues',JSON.stringify(action.payload) );
      state.value = action.payload;
    },
    updateFromDashboard: (state,action) => {
      localStorage.setItem("fromDashboard",true)
     state.fromDashboard = action.payload;
    },
    updateStatus: (state, action) => {
      state.talentStatus = action.payload;
    },
    updateSuccessObj: (state, action) => {
      state.successData = action.payload;
    },
    updateFormOptions: (state, action) => {
      state.formOptions = action.payload;
    },
    updateSelfIntroStepOneForm: (state, action) => {
      state.isUpdate = action.payload;
    },
    updateRTCUserid: (state, action) =>{
      localStorage.setItem('userId', action.payload);
      state.userId = action.payload;
    }
  },
});

// Action creators are generated for each case reducer function
export const {
  updateValues,
  updateSuccessObj,
  updateStatus,
  updateSelfIntroStepOneForm,
  updateFormOptions,
  updateFromDashboard,
  updateRTCUserid
} = selfIntroStepOneFormReducer.actions;

export default selfIntroStepOneFormReducer.reducer;
